'use strict';

var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault');

Object.defineProperty(exports, '__esModule', {
  value: true,
});
exports['default'] = void 0;

var _classCallCheck2 = _interopRequireDefault(require('@babel/runtime/helpers/classCallCheck'));

var _createClass2 = _interopRequireDefault(require('@babel/runtime/helpers/createClass'));

var _inherits2 = _interopRequireDefault(require('@babel/runtime/helpers/inherits'));

var _possibleConstructorReturn2 = _interopRequireDefault(require('@babel/runtime/helpers/possibleConstructorReturn'));

var _getPrototypeOf2 = _interopRequireDefault(require('@babel/runtime/helpers/getPrototypeOf'));

var _react = _interopRequireDefault(require('react'));

var _propTypes = _interopRequireDefault(require('prop-types'));

var _reactI18next = require('react-i18next');

function _createSuper(Derived) {
  return function () {
    var Super = (0, _getPrototypeOf2['default'])(Derived),
      result;
    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2['default'])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return (0, _possibleConstructorReturn2['default'])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var NextStaticProvider = /*#__PURE__*/ (function (_React$Component) {
  (0, _inherits2['default'])(NextStaticProvider, _React$Component);

  var _super = _createSuper(NextStaticProvider);

  function NextStaticProvider() {
    (0, _classCallCheck2['default'])(this, NextStaticProvider);
    return _super.apply(this, arguments);
  }

  (0, _createClass2['default'])(NextStaticProvider, [
    {
      key: 'render',
      value: function render() {
        var _this$props = this.props,
          children = _this$props.children,
          tReady = _this$props.tReady;
        return tReady ? children : null;
      },
    },
  ]);
  return NextStaticProvider;
})(_react['default'].Component);

NextStaticProvider.propTypes = {
  children: _propTypes['default'].node.isRequired,
  tReady: _propTypes['default'].bool,
};
NextStaticProvider.defaultProps = {
  tReady: true,
};

var _default = (0, _reactI18next.withTranslation)()(NextStaticProvider);

exports['default'] = _default;
